/* eslint-disable max-len */
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidationErrors } from '@angular/forms';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AppState } from 'src/app/store/app.reducer';
import * as DeviceActions from 'src/app/store/device/device.actions';
import { CustomValidators } from 'src/app/validators/custom.validators';
import moment from 'moment';
import { MtmaContactUnit } from 'src/app/model/mtma-unit';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { StandardDynamicComponent, StandardNewValidator, StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { TranslateService } from '@ngx-translate/core';
import { MtmaRule } from 'src/app/model/mtma-rules-access';


@Component({
	selector: 'app-mtma-manage-unit-contact-dialog',
	templateUrl: './mtma-manage-unit-contact-dialog.component.html',
	providers: [{
		provide: STEPPER_GLOBAL_OPTIONS, useValue: { showError: true }
	}]
})
export class MtmaUnitContactDialogComponent implements OnInit, OnDestroy {
	contactForm: FormGroup;

	mtmaContactModifySub: Subscription;
	contact: MtmaContactUnit;

	listRules: MtmaRule[];
	listRulesSub: Subscription;

	// design
	screenWidth: number;
	MIN_MD_WIDTH = 500;
	MAX_MD_WIDTH = 1120;
	MIN_WIDTH_COL4 = 1680;
	DELTA_ERROR_PIXEL = 7;
	MIN_TWO_BUTTONS_DIALOG_WIDTH = 575 + this.DELTA_ERROR_PIXEL;

	constructor(
		private fb: FormBuilder,
		private store: Store<AppState>,
		private nestedref: DynamicDialogRef,
		public config: DynamicDialogConfig,
		private translate: TranslateService,
	) {

	}

	ngOnInit(): void {
		if (this.config.data.contact !== undefined) {
			this.contact = this.config.data.contact;
			/*if (this.contact.DtFrom === null || this.contact.DtFrom === undefined || this.contact.DtFrom === "") {
				this.contact.DtFrom = TAGS_DEFAULT_START;
			}
			if (this.contact.DtTo === null || this.contact.DtTo === undefined || this.contact.DtTo === "") {
				this.contact.DtTo = TAGS_DEFAULT_END;
			}*/
		}

		this.store.dispatch(DeviceActions.getMtmaRulesAll());
		this.subscribeAll();
		this.buildForm();
		this.onResize();
		StandardNewValidator.setFirstCompile(true);
	}

	buildForm() {
		this.contactForm = new FormGroup({
			'Name': new FormControl({ value: this.contact.Contact.Name, disabled: true }),
			'Rule': new FormControl(this.contact.RuleId),
			'StartDate': new FormControl(this.contact.DtFrom === undefined ? null : moment(this.contact.DtFrom).toDate()),
			'StartTime': new FormControl(this.getTime(this.contact.DtFrom)),
			'EndDate': new FormControl(this.contact.DtTo === undefined ? null : moment(this.contact.DtTo).toDate()),
			'EndTime': new FormControl(this.getTime(this.contact.DtTo)),
		});
		this.contactForm.addValidators(CustomValidators.checkMatchingTemporaryRule('Rule', 'StartTime', 'EndTime', 'StartDate', 'EndDate'));
	}

	subscribeAll() {
		this.mtmaContactModifySub = this.store.select('device', 'mtmaContactModify')
			.pipe(filter(mtmaContactModifySub => !!mtmaContactModifySub))
			.subscribe(() => {
				this.resetClose();
			});
		this.listRulesSub = this.store.select('device', 'mtmaRulesAll').subscribe(listRules => {
			if (listRules === undefined) {
				this.listRules = [];
			} else {
				this.listRules = Object.assign([], listRules);
			}
			const rule = new MtmaRule();
			rule.Name = this.translate.instant('NO_GROUP');
			rule.Id = null;
			this.listRules.unshift(rule);
		});
	}

	ngOnDestroy(): void {
		this.mtmaContactModifySub?.unsubscribe();
	}

	resetClose(): void {
		this.store.dispatch(DeviceActions.resetContactForm());
		this.closeDialog();
	}

	submit(): void {
		StandardNewValidator.setFirstCompile(false);
		if (!this.getFormValidationErrors()) {
			this.save();
		}
	}

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.contactForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.contactForm.get(key).errors;
			if (controlErrors != null) {
				/* Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				}); */
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}

	save(): void {
		const rule = this.listRules.filter(item => item.Id === this.f.Rule.value)[0];
		if (this.f.Rule.value !== undefined && this.f.Rule.value !== null) {
			this.contact.RuleId = this.f.Rule.value;
			this.contact.RuleName = rule.Name;
		} else {
			this.contact.RuleId = undefined;
			this.contact.RuleName = undefined;
		}

		if (this.contact.RuleId !== null && this.contact.RuleId !== undefined &&
			this.contactForm.value.StartDate != null && this.contactForm.value.StartTime != null &&
			this.contactForm.value.EndDate != null && this.contactForm.value.EndTime != null) {
			let startTime = ''
			if (typeof this.f.StartTime.value === 'string') {
				startTime = this.f.StartTime.value;
			} else {
				startTime = moment(this.f.StartTime.value).format('HH:mm');
			}
			let endTime = ''
			if (typeof this.f.EndTime.value === 'string') {
				endTime = this.f.EndTime.value;
			} else {
				endTime = moment(this.f.EndTime.value).format('HH:mm');
			}
			//DATE VAL
			this.contact.DtFrom = moment(this.contactForm.value.StartDate).format('yyyy-MM-DDT') + startTime;
			this.contact.DtTo = moment(this.contactForm.value.EndDate).format('yyyy-MM-DDT') + endTime;
		} else {
			this.contact.DtFrom = undefined;
			this.contact.DtTo = undefined;
		}
		this.closeDialog();
	}

	getTime(date: string): string {
		if (date === undefined) {
			return '';
		}
		return moment(date).format('HH:mm');
	}


	get f(): any {
		return this.contactForm.controls;
	}

	closeDialog(): void {
		this.nestedref.close();
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	col12Responsive(): string {
		return StandardPageLayout.col6Responsive(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-30rem');
	}

	justifyContentStyle(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

	newShowErrors(type: MtmaUnitContactDialogComponent["f"], classType: string): string {
		return StandardNewValidator.newShowErrors(type, classType, this.screenWidth);
	}

	showErrorRequiredMessage(type: MtmaUnitContactDialogComponent["f"]): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}

	dynamicInputTextDesktopTabletWidth(): string {
		return StandardPageLayout.dynamicInputTextDesktopTabletWidth(this.screenWidth, 'w-20rem', 'w-30rem');
	}

	dynamicDatepicker(): string {
		return StandardDynamicComponent.dynamicDatepicker(this.screenWidth);
	}

}
